module.exports = __webpack_public_path__ + "media/images/admin/icons/archive-791d3b7501e4eab52f00db80bc35b1d5.svg";